module.exports = __webpack_public_path__ + "static/img/sustainable.237254a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/sustainable.jpg
// module id = E0IW
// module chunks = 0